import React, {useEffect} from "react";
import "./Footer.scss";
import {Version} from "../version/Version";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {getVersionAsync, selectStatus, selectVersion} from "../version/versionSlice";
import {adminPanelVersion} from "../../infrastructure/config";
import {isLoading} from "../../infrastructure/status";

export const Footer = () => {
  const dispatch = useAppDispatch();
  const apiVersion = useAppSelector(selectVersion);
  const status = useAppSelector(selectStatus);
  useEffect(() => {
    dispatch(getVersionAsync());
  }, []);

  return (
    <footer id="footer" role="contentinfo" className="footer">
      <div className="container">
        <div className="my-4 row footer-columns">
          <div className="col-sm-6 col-lg-3 footer-column">
            <div className="footer-title footer-title__subtitle">Synergi Life Mobile Service</div>
            <Version version={apiVersion} hide={isLoading(status)} />
            <div className="footer-title footer-title__subtitle">
              Synergi Life Mobile Service Admin Panel
            </div>
            <Version version={adminPanelVersion} />
          </div>
          <div className="col-sm-6 col-lg-3 footer-column">
            <div className="footer-title">Product</div>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  href="https://www.dnv.com/software/digital-asset-ecosystem/qhse-ecosystem.html"
                  className=""
                  rel="noreferrer">
                  About
                </a>
              </li>
              <li>
                <a target="_blank" href="https://www.dnv.com/news" className="" rel="noreferrer">
                  What&apos;s new
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.dnv.com/software/cases.html?"
                  className=""
                  rel="noreferrer">
                  Customer stories
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-6 col-lg-3 footer-column">
            <div className="footer-title">Help and Knowledge Centre</div>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  href="https://www.dnv.com/software/software-services/software-support.html"
                  className=""
                  rel="noreferrer">
                  Contact support
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.dnv.com/software/video-webinar/index.html"
                  className=""
                  rel="noreferrer">
                  Videos and webinars
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm-6 col-lg-3 footer-column">
            <div className="footer-title">Follow us on social media</div>
            <ul className="footer-some">
              <li className="me-4">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/showcase/dnv-digital/"
                  className="some-circle"
                  rel="noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li className="me-4">
                <a
                  target="_blank"
                  href="https://twitter.com/DNV_Group"
                  className="some-circle"
                  rel="noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li className="me-4">
                <a
                  target="_blank"
                  href="https://www.facebook.com/dnvglsoftware/"
                  className="some-facebook"
                  rel="noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.youtube.com/user/dnvsoftware"
                  className="some-circle some-youtube"
                  rel="noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom title-spacing">Copyright © DNV AS 2022</div>
    </footer>
  );
};
